import { getWindowDpr } from './dpr';

export const cssToCanvas = (x: number) => {
  const radio = getWindowDpr();
  return radio * x;
};
